const defaultUI = {
  hasLogo: true,
  hasZoom: true,
  hasSearch: true,
  hasBackButton: false,
  hasFullScreenButton: true,
};

export { defaultUI };